module.exports = __webpack_public_path__ + "static/media/4.cc4e49fd.jpg";